/**
 * Autogenerated file don't modify
 */
(function () {
var tsBuild = (function (exports) {
    'use strict';

    var util = MoyaContainer.get('core.util');
    MoyaComponents.register('site.filter', function (el) {
        var filterConfig = {
            el: el,
            filters: el.querySelectorAll('.filter a'),
            itemsSelector: el.dataset.itemSelector,
            containerSelector: el.dataset.containerSelector,
        };
        var filter = new Filter(filterConfig);
        filter.run();
    });
    var Filter = /** @class */ (function () {
        function Filter(config) {
            this.filters = config.filters;
            this.el = config.el;
            this.items = this.el.querySelectorAll(config.itemsSelector);
            this.containerSelector = config.containerSelector;
        }
        Filter.prototype.run = function () {
            this.bindFilters();
            this.checkHash();
        };
        Filter.prototype.bindFilters = function () {
            var _this = this;
            this.filters.forEach(function (filter) {
                util.delegate(filter, 'click', '#' + filter.id, function (ev) {
                    _this.el.querySelector(_this.containerSelector).classList.add('fade');
                    setTimeout(function () {
                        var target = ev.target;
                        var filterValue = target.dataset.filter;
                        if (!target.classList.contains('selected')) {
                            _this.filters.forEach(function (filter) {
                                filter.classList.remove('selected');
                            });
                            target.classList.add('selected');
                        }
                        else {
                            _this.filters.forEach(function (filter) {
                                filter.classList.remove('selected');
                            });
                            filterValue = 'all';
                        }
                        _this.items.forEach(function (item) {
                            item.style.display = 'block';
                        });
                        if (filterValue !== 'all') {
                            _this.items.forEach(function (item) {
                                if (!item.classList.contains(filterValue)) {
                                    item.style.display = 'none';
                                }
                            });
                        }
                        _this.el.querySelector(_this.containerSelector).classList.remove('fade');
                    }, 400);
                });
            });
        };
        Filter.prototype.checkHash = function () {
            var hash = location.hash.slice(1);
            var selectedHash = hash.length > 0 ? hash : '';
            if (hash) {
                var filterSelected = this.el.querySelector('.calFilter .' + selectedHash);
                if (filterSelected) {
                    filterSelected.click();
                }
            }
        };
        return Filter;
    }());

    exports.Filter = Filter;

    return exports;

}({}));
typeof tsBuild === 'function' && tsBuild();})();
